import {BaseCachedService} from './Core/BaseCachedService';

class SampleEventPhaseService extends BaseCachedService {
    get Url() { return super.Url + "/sampleEventPhases"; }
    get ModelName() { return "Sample Event Phase"; }
    get PrimaryKeyProperty() { return "sampleEventPhaseId"; }
}

export const service = new SampleEventPhaseService();

